export const dashboard = {
  hello: 'Hallo',
  projects: 'Renovationen',
  realEstates: 'Immobilien',
  components: 'Komponenten',
  craftsmen: 'Handwerker',
  appointments: 'Termine',
  toDos: 'To-dos',
  documentations: 'Unterlagen',
  evening: 'Guten Abend',
  afternoon: 'Guten Nachmittag',
  morning: 'Guten Morgen',
  noon: 'Guten Mittag',
}
